//LIBRARY
import styled, { keyframes, css } from "styled-components";

//ASSETS
import cursorIcon from "assets/img/Cursor.png";

//MISC
import { COLORS, BORDER_RADIUS, DEVICE_TYPE, SIZE } from "constants/variables";
import { UsageType } from "./SelectInputFilterModel";

const dropDown = keyframes`
  from {
    transform: translateY(-10px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const SelectInputContainer = styled.div<{
  biggerCursor?: boolean;
  type: UsageType;
}>`
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : "pointer"};
  position: relative;
  width: 250px;
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    width: 100%;
  }
  ${({ type }) =>
    type === UsageType.girdle &&
    css`
      width: auto;
      min-width: 260px;
      @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
        width: 100%;
      }
    `}
`;

export const ImgArrow = styled.img<{ isRotated: boolean }>`
  width: 16px;
  height: 10px;
  transition: transform 0.3s ease-in-out;
  transform: ${({ isRotated }) =>
    isRotated ? "rotate(180deg)" : "rotate(0deg)"};
`;

export const SelectInput = styled.div<{
  type: UsageType;
  isOpen: boolean;
}>`
  padding: 12px 24px;
  border-radius: ${BORDER_RADIUS.radius21};
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${COLORS.Background};
  color: ${COLORS.RaisinBlack};
  @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
    background-color: ${COLORS.Gunmetal};
    border-bottom-right-radius: ${({ isOpen }) =>
      isOpen === true ? "0px" : BORDER_RADIUS.radius21};
    border-bottom-left-radius: ${({ isOpen }) =>
      isOpen === true ? "0px" : BORDER_RADIUS.radius21};
  }
  ${({ type }) =>
    type === UsageType.girdle &&
    css`
      height: 48px;
      background-color: ${COLORS.Gunmetal};
      width: ${SIZE.max320};
      min-width: 260px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      gap: ${SIZE.max12};
      border: none;
      @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
        width: 100%;
      }
    `}
`;

export const Modal = styled.div<{
  type: UsageType;
}>`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  width: 100%;
  background-color: ${COLORS.Cultured};
  border-radius: ${BORDER_RADIUS.radius21};
  z-index: 110 !important;
  transition: top 0.3s ease-in-out;
  @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
    top: 48px;
    border-top-right-radius: 0px;
    border-top-left-radius: 0px;
    background-color: ${COLORS.Gunmetal};
  }
  ${({ type }) =>
    type === UsageType.girdle &&
    css`
      top: 0;
      left: 0;
      transform: translatey(-105%);
      background-color: ${COLORS.Gunmetal};
      display: flex;
      flex-direction: column;
      gap: 30px;
      @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
        top: 48px;
        transform: none;
      }
    `}
`;

export const ModalContent = styled.div<{
  type: UsageType;
}>`
  padding: 20px;
  max-height: 300px;
  overflow-y: auto;
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
    padding: 10px 20px;
    animation: ${({ isOpen }) => (isOpen ? dropDown : "none")} s ease-in-out;
  }
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: calc(100% - 40px);
    height: 1.5px;
    background-color: ${COLORS.MetalicSilver};
    margin: 0 20px;
  }
  ${({ type }) =>
    type === UsageType.girdle &&
    css`
      &::before {
        content: "";
        display: none;
      }
      @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
        padding: 10px 20px;
        animation: ${({ isOpen }) => (isOpen ? dropDown : "none")} s ease-in-out;
        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: calc(100% - 40px);
          height: 1.5px;
          background-color: ${COLORS.MetalicSilver};
          margin: 0 20px;
          display: block;
        }
      }
    `}
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
`;

export const CustomCheckbox = styled.div<{ image: string }>`
  width: 24px;
  height: 24px;
  background-image: url(${(props) => props.image});
  background-size: cover;
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
`;
